import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import React from 'react'

export default function ManageOwner() {
  return (
    <DashboardLayout><DashboardNavbar></DashboardNavbar></DashboardLayout>
  )
}
